webpackJsonp([169858455373905],{

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/who-we-are-banner.7c9bf7c4.jpg";

/***/ }),

/***/ 1461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Benefit-01.d8249f10.png";

/***/ }),

/***/ 1462:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Benefit-02.9df1f717.png";

/***/ }),

/***/ 1463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Benefit-03.730db353.png";

/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Benefit-04.cc9a71dc.png";

/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Benefit-05.e09aa011.png";

/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Benefit-06.84545364.png";

/***/ }),

/***/ 1467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Benefit-07.4a1f84b3.png";

/***/ }),

/***/ 1468:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Benefit-08.aa7b5fe8.png";

/***/ }),

/***/ 1511:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/team.85634c74.jpg";

/***/ }),

/***/ 1517:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/who-we-are-detail-01.4ca3a3d2.svg";

/***/ }),

/***/ 1518:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/who-we-are-detail-02.47a53dcb.svg";

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-wrap: wrap;\n  '], ['\n    display: flex;\n    flex-wrap: wrap;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n      margin-right: 0;\n    '], ['\n      margin-right: 0;\n    ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      margin-right: 40px;\n    '], ['\n      margin-right: 40px;\n    ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    margin-right: 40px;\n    width: calc((100% / 2) - (40px / 2));\n  '], ['\n    margin-right: 40px;\n    width: calc((100% / 2) - (40px / 2));\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    width: calc((100% / 4) - (120px / 4));\n  '], ['\n    width: calc((100% / 4) - (120px / 4));\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    padding: 100px 0;\n  '], ['\n    padding: 100px 0;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n      font-size: 60px;\n      line-height: 72px;\n      letter-spacing: -1.1px;\n    '], ['\n      font-size: 60px;\n      line-height: 72px;\n      letter-spacing: -1.1px;\n    ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    background-position: top right;\n    min-height: 960px;\n\n    &::before {\n      background-color: rgba(43, 88, 153, 0.3);\n    }\n  '], ['\n    background-position: top right;\n    min-height: 960px;\n\n    &::before {\n      background-color: rgba(43, 88, 153, 0.3);\n    }\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    padding: 100px 0 160px;\n  '], ['\n    padding: 100px 0 160px;\n  ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n    width: 50%;\n  '], ['\n    width: 50%;\n  ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n    justify-content: space-between;\n  '], ['\n    flex-direction: row;\n    justify-content: space-between;\n  ']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n    order: inherit;\n    width: calc(50% - 50px);\n\n    img {\n      max-width: 100%;\n    }\n  '], ['\n    order: inherit;\n    width: calc(50% - 50px);\n\n    img {\n      max-width: 100%;\n    }\n  ']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n    order: inherit;\n    width: calc(50% - 50px);\n  '], ['\n    order: inherit;\n    width: calc(50% - 50px);\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _reactScroll = __webpack_require__(76);
	
	var _whoWeAreBanner = __webpack_require__(1460);
	
	var _whoWeAreBanner2 = _interopRequireDefault(_whoWeAreBanner);
	
	var _MT_Benefit = __webpack_require__(1461);
	
	var _MT_Benefit2 = _interopRequireDefault(_MT_Benefit);
	
	var _MT_Benefit3 = __webpack_require__(1462);
	
	var _MT_Benefit4 = _interopRequireDefault(_MT_Benefit3);
	
	var _MT_Benefit5 = __webpack_require__(1463);
	
	var _MT_Benefit6 = _interopRequireDefault(_MT_Benefit5);
	
	var _MT_Benefit7 = __webpack_require__(1464);
	
	var _MT_Benefit8 = _interopRequireDefault(_MT_Benefit7);
	
	var _MT_Benefit9 = __webpack_require__(1465);
	
	var _MT_Benefit10 = _interopRequireDefault(_MT_Benefit9);
	
	var _MT_Benefit11 = __webpack_require__(1466);
	
	var _MT_Benefit12 = _interopRequireDefault(_MT_Benefit11);
	
	var _MT_Benefit13 = __webpack_require__(1467);
	
	var _MT_Benefit14 = _interopRequireDefault(_MT_Benefit13);
	
	var _MT_Benefit15 = __webpack_require__(1468);
	
	var _MT_Benefit16 = _interopRequireDefault(_MT_Benefit15);
	
	var _team = __webpack_require__(1511);
	
	var _team2 = _interopRequireDefault(_team);
	
	var _whoWeAreDetail = __webpack_require__(1517);
	
	var _whoWeAreDetail2 = _interopRequireDefault(_whoWeAreDetail);
	
	var _whoWeAreDetail3 = __webpack_require__(1518);
	
	var _whoWeAreDetail4 = _interopRequireDefault(_whoWeAreDetail3);
	
	var _shared = __webpack_require__(7);
	
	var _FacebookTags = __webpack_require__(108);
	
	var _FacebookTags2 = _interopRequireDefault(_FacebookTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var sp = _styles.theme.sp,
	    colors = _styles.theme.colors;
	
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__Wrapper'
	})(['background-color:', ';'], colors.white);
	
	var Grid = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__Grid'
	})(['', ';'], _styles.media.phablet(_templateObject));
	
	var GridItem = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__GridItem'
	})(['margin-bottom:20px;background-color:', ';padding:60px 30px;margin-bottom:40px;border:1px solid rgba(43,88,153,0.2);box-shadow:0 2px 4px rgba(0,0,0,0.1);border-radius:6px;text-align:center;min-height:340px;&:nth-child(2n){', ';', ';}&:nth-child(4n){', ';}', ';', ';'], colors.blueIce, _styles.media.phablet(_templateObject2), _styles.media.desktop(_templateObject3), _styles.media.desktop(_templateObject2), _styles.media.phablet(_templateObject4), _styles.media.desktop(_templateObject5));
	
	var GridText = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__GridText'
	})(['font-size:16px;line-height:20px;']);
	
	var GridIcon = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__GridIcon'
	})(['display:inline-block;margin:0 0 60px;width:100px;height:100px;border-radius:50%;background-color:', ';img{max-width:100%;}'], colors.white);
	
	var Banner = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__Banner'
	})(['position:relative;background-image:url(\'', '\');background-size:cover;background-position:top right -260px;background-repeat:no-repeat;padding:60px 0 100px;', ';h1{color:', ';max-width:600px;font-size:32px;line-height:40px;letter-spacing:-0.8px;margin-top:', ';margin-bottom:', ';font-weight:700;', ';}&::before{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(43,88,153,0.7);content:\'\';}', ';'], function (props) {
	  return props.src;
	}, _styles.media.tablet(_templateObject6), colors.white, sp.l, sp.xl, _styles.media.tablet(_templateObject7), _styles.media.tablet(_templateObject8));
	
	var Wedge = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__Wedge'
	})(['position:absolute;width:110%;bottom:0;left:-10%;&::after{position:absolute;left:0;bottom:0;width:100%;height:1px;background-color:', ';content:\'\';}svg{display:block;}'], colors.blueIce);
	
	var Intro = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__Intro'
	})(['background-color:', ';padding:60px 0 100px;margin-bottom:100px;', ';h2{margin:0 0 20px;font-size:36px;line-height:43px;}'], colors.blueIce, _styles.media.tablet(_templateObject9));
	
	var Benefits = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__Benefits'
	})(['padding:100px 0 160px;text-align:center;h2{margin:0 0 60px;font-size:36px;line-height:43px;}']);
	
	var Team = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__Team'
	})(['position:relative;background-image:url(\'', '\');background-size:cover;background-position:center center;background-repeat:no-repeat;padding:100px 0;min-height:580px;&::before{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(43,88,153,0.7);content:\'\';}'], function (props) {
	  return props.src;
	});
	
	var TeamWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__TeamWrapper'
	})(['display:flex;justify-content:flex-end;']);
	
	var TeamContent = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__TeamContent'
	})(['', ';h2{margin:0 0 20px;font-size:36px;line-height:43px;color:', ';}p{color:rgba(255,255,255,0.7);margin:0 0 30px;}'], _styles.media.tablet(_templateObject10), colors.white);
	
	var Detail = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__Detail'
	})(['padding:0 0 100px;']);
	
	var DetailWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__DetailWrapper'
	})(['display:flex;flex-direction:column;', ';'], _styles.media.tablet(_templateObject11));
	
	var DetailImage = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__DetailImage'
	})(['order:1;text-align:center;img{max-width:80%;}', ';'], _styles.media.tablet(_templateObject12));
	
	var DetailContent = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'who-we-are__DetailContent'
	})(['order:2;padding-top:40px;h2{margin:0 0 20px;font-size:36px;line-height:43px;}p{margin:0 0 30px;}', ';'], _styles.media.tablet(_templateObject13));
	
	function WhoWeAre() {
	  var breadcrumbs = [{
	    name: 'Home',
	    link: '/'
	  }, {
	    name: 'Who We Are',
	    link: '/who-we-are'
	  }];
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_shared.SeoTags, {
	      title: 'About MarketTap | MarketTap',
	      description: 'MarketTap provides affordable and easy on demand marketing services when and as you need it. Our services help our clients sell more online. Learn more today.'
	    }),
	    _react2.default.createElement(_FacebookTags2.default, {
	      fbUrl: ("https://markettap.com") + '/who-we-are/',
	      fbTitle: 'About MarketTap | MarketTap',
	      fbDescription: 'MarketTap provides affordable and easy on demand marketing services when and as you need it. Our services help our clients sell more online. Learn more today.',
	      fbImage: _whoWeAreBanner2.default
	    }),
	    _react2.default.createElement(
	      Banner,
	      { src: _whoWeAreBanner2.default },
	      _react2.default.createElement(
	        Wedge,
	        null,
	        _react2.default.createElement(
	          'svg',
	          { viewBox: '0 0 1400 100' },
	          _react2.default.createElement('polygon', { points: '0 0 1400 100 0 100', fill: '#f7faff' })
	        )
	      ),
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(_shared.Breadcrumbs, { breadcrumbs: breadcrumbs, left: true, light: true }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Our mission is to help our clients sell more online.'
	        ),
	        _react2.default.createElement(
	          _reactScroll.Link,
	          { to: 'proactiveStrategy', smooth: true, duration: 1000 },
	          _react2.default.createElement(
	            _shared.Button,
	            { yellow: true, scroll: true },
	            'Get Started'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactScroll.Element,
	      { name: 'proactiveStrategy' },
	      _react2.default.createElement(
	        Intro,
	        null,
	        _react2.default.createElement(
	          _shared.Container,
	          { narrow: true },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Proactive Strategy'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Here at MarketTap, we define marketing success as the implementation of a proactive strategy that applies the right mix of marketing activities in order to get the results you want, ultimately achieving your business goals. With so many moving parts marketing isn\u2019t easy and we know that, but it\u2019s an important part of your business\u2019 success.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Detail,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          DetailWrapper,
	          null,
	          _react2.default.createElement(
	            DetailImage,
	            null,
	            _react2.default.createElement('img', { src: _whoWeAreDetail2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            DetailContent,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Seamless Interactions'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We want to make your interactions with us completely seamless and efficient. That\u2019s why we designed an online platform where you can easily buy and manage your marketing services. MarketTap was created to provide on-demand marketing support for small-to-medium businesses, and unlike traditional marketing agencies, with MarketTap there are no contracts or retainer fees!'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Detail,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          DetailWrapper,
	          null,
	          _react2.default.createElement(
	            DetailContent,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Marketing your business just got a whole lot easier.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Whether you are looking for social media management, photography, content writing or a social media strategy, our pay-as-you-go model means you can simply buy the services you need, when you need them!'
	            ),
	            _react2.default.createElement(
	              _shared.Button,
	              { to: '/how-it-works', yellow: true },
	              'See how it works'
	            )
	          ),
	          _react2.default.createElement(
	            DetailImage,
	            null,
	            _react2.default.createElement('img', { src: _whoWeAreDetail4.default, alt: '' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Team,
	      { src: _team2.default },
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          TeamWrapper,
	          null,
	          _react2.default.createElement(
	            TeamContent,
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'The team that makes it all possible'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We are a passionate and diverse team of marketing superstars that understand the stresses that small businesses and e-commerce companies face.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We work to create amazing marketing services that offer a return on investment that will benefit your business. Whether you\u2019ve been in business for years or just starting out \u2013 know that our team of professionals is are in your corner and here to help you become the best that you can be.'
	            ),
	            _react2.default.createElement(
	              _shared.Button,
	              { to: '/services', yellow: true },
	              'Shop Services'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Benefits,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'What makes us unique!'
	        ),
	        _react2.default.createElement(
	          Grid,
	          null,
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Benefit2.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'A la carte marketing services - pick and choose what only you need.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Benefit4.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'Ability to buy and manage services within our platform.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Benefit6.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'Simple and affordable, pay-as-you-go pricing.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Benefit8.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'Quick and transparent delivery timelines.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Benefit10.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'No contracts or retainer fees.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Benefit12.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'High-quality work delivered every time!'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Benefit14.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'Our team of experts, available on-demand.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Benefit16.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'Exceptional client satisfaction.'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = WhoWeAre;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-who-we-are-js-77cb20a51386a333d2b3.js